var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.9,21.5l-1.4-1.4,3.1-3.1h-2.6v-2h6v6h-2v-2.6l-3.1,3.1ZM20.1,21.5l-3.1-3.1v2.6h-2v-6h6v2h-2.6l3.1,3.1-1.4,1.4ZM3,9v-2h2.6l-3.1-3.1,1.4-1.4,3.1,3.1v-2.6h2v6H3ZM15,9V3h2v2.6l3.1-3.1,1.4,1.4-3.1,3.1h2.6v2h-6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInMap);
export default __webpack_public_path__ + "static/media/zoom_in_map.7c493d8c22e8c65b3e9521dba2ac2644.svg";
export { ForwardRef as ReactComponent };